import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { Form } from '../../../../components/form/Form';
import { Input } from '../../../../components/form/Input';
import SubmitButton from '../../../../components/form/SubmitButton';
import { useLogin } from '../../../../hooks/useLogin';
import { useMutationErrorHandler } from '../../../../hooks/useMutationErrorHandler';
import {
  Flair__Employee__C,
  useRegisterMutation,
} from '../../__generated__/graphql';
import { ApiTokenType } from '../../../../context/AuthContext';

type Props = {
  employee: Flair__Employee__C;
  organizationId: string;
  token: string;
};

type FormData = {
  password: string;
};

const formSchema = yup.object().shape<FormData>({
  password: yup.string().required().min(8),
});

const RegistrationForm: React.FC<Props> = ({
  token,
  organizationId,
  employee,
}) => {
  const [serverErrors, setServerErrors] = useState<boolean>(false);
  const login = useLogin();
  const { t } = useTranslation();
  const [doRegister] = useRegisterMutation();
  const errorHandler = useMutationErrorHandler();

  const handleSubmit = (apiToken: string | undefined | null) => {
    if (!apiToken) {
      setServerErrors(true);
      return;
    }

    login(apiToken, ApiTokenType.LEGACY);
  };

  const onSubmit = async ({ password }: FormData) => {
    setServerErrors(false);
    await doRegister({
      variables: { token, organizationId, password },
    })
      .then(({ data }) => handleSubmit(data?.register?.apiToken))
      .catch(errorHandler);
  };

  return (
    <>
      <h1 className="display-4 text-center mb-3">
        {t('registration.title', { name: employee.flair__First_Name__c })}
      </h1>
      <p className="text-muted text-center mb-5">
        {t('registration.subTitle')}
      </p>
      <Form
        onSubmit={onSubmit}
        validationSchema={formSchema}
        defaultValues={{ password: '' }}>
        <Input
          label={t('form.general.passwordNew.label')}
          placeholder={t('form.general.passwordNew.placeholder')}
          name="password"
          type="password"
        />

        {serverErrors ? (
          <p className="text-danger">{t('signIn.invalid')}</p>
        ) : (
          <></>
        )}

        <SubmitButton block>{t('registration.button')}</SubmitButton>
      </Form>
    </>
  );
};

export default RegistrationForm;
